import * as THREE from 'three';
import {
  ControlPointObjectType,
  DrainFunnelObjectType,
  LinkingPointObjectType,
} from '../constructor/types';
import { VariantType } from 'notistack';

export const EventSelectLinkingLine = 'SELECT_LINE';
export const EventSelectControlPoint = 'SELECT_CONTROL_POINT';
export const EventSelectDrainFunnel = 'SELECT_DRAIN_FUNNEL';
export const EventRemoveDrainFunnel = 'REMOVE_DRAIN_FUNNEL';
export const EventUpdateDrainFunnel = 'UPDATE_DRAIN_FUNNEL';
export const EventStartNotification = 'START_NOTIFICATION';
export const EventUpdateControlPoint = 'UPDATE_CONTROL_POINT';
export const EventSelectInput = 'SELECT_INPUT';
export const EventAddSubstrate = 'EVENT_ADD_SUBSTRATE';
export const EventChangeSector = 'EVENT_CHANGE_SECTOR';
export const EventChangeScaleObject = 'EVENT_CHANGE_SCALE_OBJECT';
export const EventUpdateSizeScale = 'EVENT_UPDATE_SIZE_SCALE';

export type EventSelectLinkingDetailType = {
  position: THREE.Vector2;
  selectObject: LinkingPointObjectType;
};
export type EventSelectControlPointDetailType = {
  position: THREE.Vector2;
  selectObject: ControlPointObjectType;
};
export type EventSelectDrainFunnelDetailType = {
  position: THREE.Vector2;
  selectObject: DrainFunnelObjectType;
  uuidPointMove: string;
};
export type EventStartNotificationType = {
  message: string;
  messageType: VariantType;
};
export type SideBetweenControlPointType = {
  length: number;
  nameStart: string;
  nameEnd: string;
  angleStart: number;
  angleEnd: number;
};
export type SelectInputType = {
  nameSide: string;
};
export type EventUpdateSizeScaleType = {
  size: number;
};
export type EventChangeSectorType = {
  isSector: boolean;
};
export type EventChangeScaleObjectType = {
  isObjectScale: boolean;
};

declare global {
  interface DocumentEventMap {
    [EventSelectLinkingLine]: CustomEvent<EventSelectLinkingDetailType>;
    [EventSelectControlPoint]: CustomEvent<EventSelectControlPointDetailType>;
    [EventStartNotification]: CustomEvent<EventStartNotificationType>;
    [EventSelectInput]: CustomEvent<SelectInputType>;
    [EventSelectDrainFunnel]: CustomEvent<EventSelectDrainFunnelDetailType>;
    [EventChangeSector]: CustomEvent<EventChangeSectorType>;
    [EventChangeScaleObject]: CustomEvent<EventChangeScaleObjectType>;
    [EventUpdateSizeScale]: CustomEvent<EventUpdateSizeScaleType>;
  }
}
